module.exports = __webpack_public_path__ + "static/img/newenergy2.e6b91d5f.png";